import { Grid } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../../Components/MaterialButtonStyle/StyleButton";
import CustomModal from "../../../Components/Modal/CustomModal";
import CustomCheckBox from "../../../Components/CheckBox/CustomCheckBox";
const CerificateModal = ({fileExtentions, certificateImageModal, certificateName, CloseCerticateImage, UpdateCerficate, imageUrl, isEdit, selectedIndex, certificateSelectList, setCertificateSelectList }) => {

  const UpdateData = () => {
    if (!certificateSelectList) {
      toast.error("Please Select Document Verification");
      return
    }

    if (!certificateSelectList.Yes && !certificateSelectList.No) {
      toast.error("Please Select Document Verification");
      return
    }
    if (certificateSelectList.Yes) {
      UpdateCerficate(certificateSelectList.Yes, selectedIndex, "verified")
    } else if (certificateSelectList.No) {
      UpdateCerficate(certificateSelectList.No, selectedIndex, "unVerified")
    } else {
      UpdateCerficate(false, selectedIndex, "unVerified")
    }

  }
  const HandleCertificateVerificationChange = (value, field) => {
    var updatedQualificationData = {}

    if (field === "Yes" && value == true) {
      updatedQualificationData = { Yes: true, No: false };
    } if (field === "No" && value == true) {
      updatedQualificationData = { Yes: false, No: true };
    } else if (!value) {
      updatedQualificationData = { No: false, Yes: false };
    }

    setCertificateSelectList(updatedQualificationData);
  }

  return (
    <CustomModal
      open={certificateImageModal}
      setOpen={CloseCerticateImage}
      divider={false}
      header={true}
      width={"52%"}
      modalTitle={
        <h5 className="poppinsSemiBold Text-Prime-Black text-left">
          View {certificateName ? certificateName : "--"}
        </h5>
      }
      contentScroll={true}
      modalContent={
        <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"center"} alignItems={"center"} className="p-5">
          <Grid item lg={10} md={10} sm={10} xs={10} overflow={"hidden"} alignItems={"center"} justifyContent={"center"} className="p-5">

            {fileExtentions =="pdf"?
              <iframe
                src={imageUrl}
                width="100%"
                height="600px"
                title="Preview image"
                style={{ border: "none" }}
              ></iframe>
              :
              <img src={imageUrl} alt="CertificateImage" style={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
                objectFit: "contain",
              }} className="img_fluid" />
            }
          </Grid>

          {isEdit &&
            <Grid item lg={12} md={10} sm={10} xs={10} container alignItems={"center"} justifyContent={"space-between"} className="">

              <Grid item lg={5.5} md={6} sm={6} xs={6} container flexDirection={"row"} alignItems={"center"} justifyContent={"flex-end"}>
                <CustomCheckBox

                  disableColor={"transparent"}
                  checked={certificateSelectList?.Yes}
                  onChange={() => HandleCertificateVerificationChange(!certificateSelectList?.Yes, "Yes")}
                />
                <p className="poppinsRegular Text-Prime-Black text-center">
                  Mark as Verified and okay
                </p>
              </Grid>

              <Grid item lg={5.5} md={5.5} sm={5.5} xs={6} container flexDirection={"row"} alignItems={"center"} justifyContent={"flex-start"}>
                <CustomCheckBox
        
                  disableColor={"transparent"}
                  checked={certificateSelectList?.No}
                  onChange={() => HandleCertificateVerificationChange(!certificateSelectList.No, "No")}
                />
                <p className="poppinsRegular Text-Prime-Black text-center">
                  Reject Certificate and mark as not okay
                </p>
              </Grid>

            </Grid>}

        </Grid>
      }

      modalFooter={
        isEdit &&
        <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
          <PrimeGrayBorderColorButton
            type="submit"
            className="px-3 py-2"
            onClick={() => CloseCerticateImage()}
          >
            Close
          </PrimeGrayBorderColorButton>
          <GreenColorButton
            type="submit"
            className="px-3 py-2 ml-3"
            onClick={() => UpdateData()}
          >
            Update
          </GreenColorButton>
        </Grid>

      }
    />

  );
};

export default CerificateModal;
